// From System.options.data_store_item_keys
export type DataStoreItemKeyModel = {
  id: number,
  title: string,
  value: string,
}

const state = {
  id: null,
  title: '',
  value: '',
}

export const requiredFields = [
  { key: 'title' },
  { key: 'value' },
]

export default state
